import React from "react";
import axios from "axios";
import SelectedStrategy from "./SelectedStrategy";
import GetCSRFToken from "../../AuthComponents/GetCSRFToken";

function outProcessSelectedStrategyList(ssl: SelectedStrategy[]) {
    if (ssl === undefined) {
      return {
        configuredStrategies: [],
      };
    }
    return {
      configuredStrategies: ssl.map((selectedStrategy) => ({
        ...selectedStrategy,
        strategyDisplayProps: null,
        currentlyDisplayed: false,
      })),
    };
  }
  
  function PostSelectedStrategyList(
    ssl: SelectedStrategy[],
    setStrategyMetadata: (newStrategyMetadata: { [key: string]: any }) => void, handleSuccessNotification: () => void) { 
    axios
      .post("/api/strategy/configured", outProcessSelectedStrategyList(ssl), {
        headers: { "X-CSRFToken": GetCSRFToken() },
      })
      .then((res) => {
        const strategyMetadata = res.data.strategy_metadata ?? {};
        setStrategyMetadata(strategyMetadata);
        handleSuccessNotification();
      })
      .catch((error) => {
        if (process.env.NODE_ENV === "development") {
              console.log(error.response);
            }; // TODO: instead of closing dialogue communicate about the error
      })
      .finally(() => {});
  }

export default PostSelectedStrategyList;